import _ from 'lodash';
import { OptionDefinition } from '@amzn/awsui-components-react-v3/polaris/internal/components/option/interfaces';

// ParameterKeys are to be standard between receive and receive exceptions.  If you change something
// here you MUST also make that change on the receive end here:
// https://code.amazon.com/packages/DCReceiveWebUIWebsite/blobs/mainline/--/src/redux/receive/util/ReceiveExceptionsUrl.js
export const ParameterKeys = {
  exceptionType: 'exceptionType',
  po: 'poNumber',
  shipmentId: 'shipmentId',
  trackingId: 'trackingId',
  duplicateSerial: 'duplicateSerialId',
  modelId: 'modelId'
};

// Maps from properties in ExceptionTypeOptionsProps to the url parameter key.
const FormValuesToParamMapping = {
  exceptionType: ParameterKeys.exceptionType,
  model: ParameterKeys.modelId,
  orderNumber: ParameterKeys.po,
  shipmentReferenceId: ParameterKeys.shipmentId,
  trackingNumber: ParameterKeys.trackingId,
  serial: ParameterKeys.duplicateSerial
};

/**
 * Parses url parameters and returns initial form values allowing for an autofill workflow from
 * receive -> receive exceptions.  Also returns a touched object which can be given to Formik to let it know
 * what properties to check against the scheme onMount.
 */
export function getAutoFilledFormValuesFromUrlParameters(exceptionTypes: OptionDefinition[]): { [name: string]: string } {
  let newFormValues:any = {};
  // Autofill the inputs for given parameter keys
  const searchParams = new URLSearchParams(window.location.hash.substring(1));
  if (searchParams.has(ParameterKeys.exceptionType)) {
    const paramVal = searchParams.get(ParameterKeys.exceptionType);
    if (paramVal) {
      const eType = decodeURIComponent(paramVal);
      if (eType) {
        const exceptionTypeOption = _.find(exceptionTypes, {value: eType}) as OptionDefinition;
        if (exceptionTypeOption) {
          newFormValues['exceptionType'] = exceptionTypeOption;
        }
      }
    }
  }

  Object.entries(FormValuesToParamMapping).forEach(entry => {
    const [formKey, paramKey] = entry;
    if (paramKey !== ParameterKeys.exceptionType && searchParams.has(paramKey)) {
      const paramVal = searchParams.get(paramKey);
      if (paramVal) {
        const value = decodeURIComponent(paramVal);
        if (value != null && !/[[/\]{}()<>"'.,\\^$|#\s]/g.test(value)) {
          newFormValues[formKey] = value;
        }
      }
    }
  })
 
  return newFormValues;
}